import { cn } from 'cn';

type P = {
  readonly direction?: 'top' | 'right' | 'bottom' | 'left';
} & ComponentStyling;

export const Triangle = ({ className, direction = 'right', style }: P) => (
  <div
    className={cn(
      'size-0 border-t-[16px] border-b-[16px] border-l-[24px] border-t-transparent border-b-transparent border-l-tiga-border-lighter',
      {
        'rotate-180': direction === 'left',
      },
      className,
    )}
    style={style}
  />
);
